module.exports = __webpack_public_path__ + "files/07b1396d2fa55a6b4633c173aff34502.png";